// extracted by mini-css-extract-plugin
module.exports = {"createWrap":"Slides_createWrap__2cbf-"};